import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useParams } from "react-router-dom";
import { Table as TB } from "antd";
import callApi from "../../../helpers/callApi";
import TitleHeader from "../../accounts/Components/TitleHeader";
function Shopkeepers(props) {
  const branchId = useParams().branchId;

  const shopkeeperColumns = [
    {
      title: "S.no",
      dataIndex: "sno",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Address",
      dataIndex: "address",
      width: "20%",
    },
  ];
  const [totalNumber, setTotalNumber] = useState();
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [filters, setFilters] = useState();
  const [shopKeeperList, setShopKeeperList] = useState([]);

  let pageSizeValue = 20;
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: pageSizeValue,
      showSizeChanger: true,
      pageSizeOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
    },
  });

  let paging = { current: 1 };
  const handleTableChange = async (pagination, filter, sorter) => {
    pageSizeValue = pagination.pageSize;
    setTableParams({ pagination, filter, ...sorter });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setShopKeeperList([]);
    }
    const params = { size: pagination.pageSize };
    paging.current = pagination.current;
    if (filters) {
      let fils = filters;
      fils.page = pagination.current;
      fils.pageSize = pageSizeValue;
      await getShopKeeperList(fils);
    } else {
      await getShopKeeperList(params);
    }
  };

  // const onFilter = async (values) => {
  //   setIsFilter(true);
  //   setTableParams({
  //     ...tableParams,
  //     pagination: {
  //       ...tableParams.pagination,
  //       current: 1,
  //     },
  //   });
  //   let params = {
  //     page: 1,
  //   };
  //   paging.current = 1;
  //   params.institute_enrollment__institute = values.filterInstitute?.value;
  //   params.main_province = values.main_province?.value;

  //   setFilters(params);
  //   localStorage.setItem("shopParams", JSON.stringify(params));
  //   fetchData(params);
  // };

  const getShopKeeperList = async (params = {}) => {
    setLoading(true);
    let endpoint = `shopkeepers/?branchId=${branchId}`;
    const params1 = {
      ...params,
      page: !isFilter ? paging.current - 1 : params.page - 1 || 0,
      size: pageSizeValue || null,
    };
    await callApi(endpoint, null, null, params1)
      .then((response) => {
        setShopKeeperList(response.data);
        const total = response.headers.get("x-total-count");
        setTotalNumber(total);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getShopKeeperList();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="container" style={{ marginTop: 100 }}>
        <div class="content">
          <TitleHeader title={`Shopkeepers List-(${totalNumber})`} />
          <div class="card">
            <div class="card-body">
              <div class="card" id="filter_inputs">
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <input type="text" placeholder="Enter User Name" />
                      </div>
                    </div>
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <input type="text" placeholder="Enter Phone" />
                      </div>
                    </div>
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <input type="text" placeholder="Enter Email" />
                      </div>
                    </div>
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <select class="select">
                          <option>Disable</option>
                          <option>Enable</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-1 col-sm-6 col-12 ms-auto">
                      <div class="form-group">
                        <a class="btn btn-filters ms-auto">
                          <img
                            src="/assets/img/icons/search-whites.svg"
                            alt="img"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TB
                class="table-responsive table"
                style={{ fontSize: 25, fontFamily: "arial" }}
                size="large"
                columns={shopkeeperColumns}
                pagination={tableParams.pagination}
                onChange={handleTableChange}
                loading={loading}
                dataSource={shopKeeperList?.map((item, index) => ({
                  key: item._id,
                  sno: index + 1,
                  name: <p>{item.name}</p>,
                  phone: item.phone,
                  address: item.address,
                }))}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Shopkeepers;
